<template>
  <div>
    <div class="mb-3">
      กรุณากรอกข้อมูลในช่องที่มีเครื่องหมาย
      <span class="red--text">*</span> ให้ครบ
    </div>

    <ValidationObserver ref="observer">
      <ValidationProvider
        name="ชื่อ Name"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            ชื่อ Name <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="input.name"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="ชื่อ Name"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>
      <ValidationProvider
        name="นามสกุล Last Name"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            นามสกุล Last Name <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="input.surname"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="นามสกุล Last Name"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>
      <ValidationProvider
        name="อีเมล Email address"
        :rules="{ required: true, email: true }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            อีเมล Email address <span class="red--text">*</span>
          </div>
          <v-text-field
            dense
            v-model="input.email"
            label
            outlined
            :error-messages="errors"
            :success="input.email ? valid : false"
            :hide-details="errors.length == 0"
            placeholder="อีเมล Email address"
          ></v-text-field>
        </div>
      </ValidationProvider>
      <ValidationProvider
        name="เบอร์โทรศัพท์มือถือ Phone No."
        :rules="{ required: true, regex: /^[0][3-9]-[0-9]{4}-[0-9]{4}$/ }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            เบอร์โทรศัพท์มือถือ Phone No. <span class="red--text">*</span>
          </div>

          <v-text-field
            name="เบอร์โทรศัพท์มือถือ Phone No."
            :key="'phone'"
            ref="mobilephone"
            dense
            v-model="input.phone"
            label
            outlined
            v-mask="'##-####-####'"
            type="tel"
            placeholder="เบอร์โทรศัพท์มือถือ Phone No."
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </div>
      </ValidationProvider>
      <ValidationProvider
        name="ประเภทกรมธรรม์ Policy type"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            ประเภทกรมธรรม์ Policy type <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                dense
                :items="policyTypeOptions"
                v-model="input.policy_type"
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="ประเภทกรมธรรม์ Policy type"
                item-text="label"
                item-value="value"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>
      <template v-if="input.policy_type && input.policy_type === 'G'">
        <ValidationProvider
          name=" ชื่อบริษัท Company name"
          :rules="{
            required: true,
          }"
          v-slot="{ errors, valid }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              ชื่อบริษัท Company name <span class="red--text">*</span>
            </div>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="input.company_name"
                  label
                  outlined
                  :error-messages="errors"
                  :success="valid"
                  :hide-details="errors.length == 0"
                  placeholder="ชื่อบริษัท Company name"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </ValidationProvider>
      </template>
      <template v-if="input.policy_type && input.policy_type !== 'G'">
        <ValidationProvider
          name="เลขกรมธรรม์ Policy No"
          :rules="{
            required: true,
            regex: /^[a-zA-Z0-9-]+$/,
          }"
          :custom-messages="{
            regex:
              'เลขกรมธรรม์ Policy No สามารถมีตัวอักษร ตัวเลข และเครื่องหมายขีดกลาง (-)',
          }"
          v-slot="{ errors, valid }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              เลขกรมธรรม์ Policy No <span class="red--text">*</span>
            </div>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="input.policy_no"
                  label
                  outlined
                  :error-messages="errors"
                  :success="valid"
                  :hide-details="errors.length == 0"
                  placeholder="เลขกรมธรรม์ Policy No"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </ValidationProvider>
      </template>
      <ValidationProvider
        name="บัตรประชาชน ID Card"
        :rules="{
          required: true,
          regex: /^[0-9-]{13}|(?!^0+$)[a-zA-Z0-9]{3,20}$/,
          idcard: true,
          integer: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            บัตรประชาชน ID Card <span class="red--text">*</span>
          </div>
          <v-text-field
            dense
            @input="input.id_card_no = numberOnly($event)"
            v-model.number="input.id_card_no"
            maxlength="17"
            label
            v-mask="'X-XXXX-XXXXX-XX-X'"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            outlined
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
            placeholder="บัตรประชาชน ID Card"
          ></v-text-field>
        </div>
      </ValidationProvider>
      <div>
        <div class="font-weight-bold">
          ประเภทการเคลม
          <span class="red--text">*</span>
        </div>
        <div class="pt-4 mb-4">
          <v-layout wrap row>
            <v-flex xs6 class="px-3">
              <div
                :style="{
                  backgroundColor:
                    input.claim_type === 'ผู้ป่วยนอก (OPD)'
                      ? '#c5281d '
                      : '#FFE6E4',
                  color:
                    input.claim_type === 'ผู้ป่วยนอก (OPD)'
                      ? '#FFFFFF'
                      : '#CA8383',
                  lineHeight: '1.3',
                  fontSize: '14px',
                  cursor: 'pointer',
                }"
                class="text-center py-2"
                @click="input.claim_type = 'ผู้ป่วยนอก (OPD)'"
              >
                <div>ผู้ป่วยนอก</div>
                <div>(OPD)</div>
              </div>
            </v-flex>
            <v-flex xs6 class="px-3">
              <div
                :style="{
                  backgroundColor:
                    input.claim_type === 'ผู้ป่วยใน (IPD)'
                      ? '#c5281d '
                      : '#FFE6E4',
                  color:
                    input.claim_type === 'ผู้ป่วยใน (IPD)'
                      ? '#FFFFFF'
                      : '#CA8383',
                  lineHeight: '1.3',
                  fontSize: '14px',
                  cursor: 'pointer',
                }"
                class="text-center py-2"
                @click="input.claim_type = 'ผู้ป่วยใน (IPD)'"
              >
                <div>ผู้ป่วยใน</div>
                <div>(IPD)</div>
              </div>
            </v-flex>

            <v-flex xs12 class="mx-3 mt-2" style="color: #666666">
              <v-layout wrap row>
                <v-flex
                  xs6
                  class="px-3 text-center py-2"
                  style="font-size: 14px"
                >
                  <div>ยอดเคลมสูงสุดไม่เกิน</div>
                  <div>5,000 บาท</div>
                </v-flex>
                <v-flex
                  xs6
                  class="px-3 text-center py-2"
                  style="font-size: 14px"
                >
                  <div>ยอดเคลมสูงสุดไม่เกิน</div>
                  <div>20,000 บาท</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <ValidationProvider
        name="ประเภทการรักษา"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            ประเภทการรักษา Coverage Type <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                dense
                :items="treatmentTypeOptions"
                v-model="input.treatment"
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="ประเภทการรักษา"
                item-text="label"
                item-value="value"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>

      <ValidationProvider
        name="ใส่จำนวนค่ารักษาตามใบเสร็จของโรงพยาบาล"
        :rules="{
          required: true,
        }"
        v-slot="{ errors, valid }"
      >
        <div class="mb-4" :class="{ 'has-error': errors[0] }">
          <div class="font-weight-bold">
            จำนวนค่ารักษาตามใบเสร็จ Amount (THB)
            <span class="red--text">*</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                type="number"
                dense
                v-model="input.medical_expenses"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
                placeholder="ใส่จำนวนค่ารักษาตามใบเสร็จของโรงพยาบาล"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </ValidationProvider>

      <div class="mt-6">
        <h4 class="mb-3">อัปโหลดไฟล์เอกสารเพิ่มเติม</h4>

        <ValidationProvider
          name="เอกสารใบเสร็จ Upload Receipt"
          :rules="{ required: true }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              อัปโหลดเอกสารใบเสร็จ Upload Receipt
              <span class="red--text">*</span>
            </div>
            <div style="min-height: 90px; cursor: pointer">
              <UploadSingleFile
                :errors="errors"
                v-model="input.receipt_file"
                :showRemark="true"
                >Upload Receipt</UploadSingleFile
              >
            </div>
            <div class="red--text error-text py-0" v-if="errors.length">
              กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="ใบรับรองแพทย์ Upload Medical Certificate"
          :rules="{ required: true }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              อัปโหลดใบรับรองแพทย์ Upload Medical Certificate
              <span class="red--text">*</span>
            </div>
            <div style="min-height: 90px; cursor: pointer">
              <UploadSingleFile
                :errors="errors"
                v-model="input.medical_citificate_file"
                :showRemark="true"
                >Upload Medical Certificate</UploadSingleFile
              >
            </div>
            <div class="red--text error-text py-0" v-if="errors.length">
              กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="รูปบัตรประชาชน Upload ID Card"
          :rules="{ required: true }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              อัปโหลดรูปบัตรประชาชน Upload ID Card
              <span class="red--text">*</span>
            </div>
            <div style="min-height: 90px; cursor: pointer">
              <UploadSingleFile
                :errors="errors"
                v-model="input.national_id_card_photo"
                :showRemark="true"
                >Upload ID Card</UploadSingleFile
              >
            </div>
            <div class="red--text error-text py-0" v-if="errors.length">
              กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="หน้าสมุดบัญชี Upload Book Bank"
          :rules="{ required: true }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">
              อัปโหลดหน้าสมุดบัญชี Upload Book Bank
              <span class="red--text">*</span>
            </div>
            <div style="min-height: 90px; cursor: pointer">
              <UploadSingleFile
                :errors="errors"
                v-model="input.book_bank_file"
                :showRemark="true"
                >Upload Book Bank</UploadSingleFile
              >
            </div>
            <div class="red--text error-text py-0" v-if="errors.length">
              กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="เอกสารอื่นๆ Upload Other"
          :rules="{ required: false }"
          v-slot="{ errors }"
        >
          <div class="mb-4" :class="{ 'has-error': errors[0] }">
            <div class="font-weight-bold">อัปโหลดเอกสารอื่นๆ Upload Other</div>
            <div style="min-min-height: 90px">
              <UploadMultipleFile
                :errors="errors"
                v-model="input.other_file"
                :maxUploadFile="2"
                >Upload Other</UploadMultipleFile
              >
            </div>
            <div class="red--text error-text py-0" v-if="errors.length">
              กรุณาอัปโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="pt-2">
        <v-layout>
          <v-flex>
            <v-checkbox
              v-model="acceptConsent"
              class="mx-2 mt-0"
              color="primary"
            ></v-checkbox>
          </v-flex>
          <v-flex style="padding-right: 48px">
            <div class="mb-4">
              ข้าพเจ้ายืนยันว่าข้อมูลข้างต้นเป็นข้อมูลที่ถูกต้องแท้จริงของข้าพเจ้า
              พร้อมรับทราบว่าเจนเนอราลี่ ทำการประมวลข้อมูล ส่วนบุคคล
              รวมถึงข้อมูลสุขภาพตาม นโยบายส่วนบุคคล
              และตกลงตามเงื่อนไขการใช้บริการเรียกร้องค่าสินไหมผ่าน
              ช่องทางออนไลน์
            </div>
            <div>
              I hereby confirmed that my personal data above is correct and true
              and acknowledged that Generali shall process my personal data and
              health data in accordance with Generali's Privacy Policy. I hereby
              agreed to the terms and conditions with respect to claim services
              via online channel
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="text-center mt-10">
        <v-btn
          @click="handleSubmit"
          color="primary"
          depressed
          block
          large
          :loading="loading"
          :disabled="!acceptConsent"
        >
          <span style="font-size: 18px">ส่งเอกสาร / SUBMIT</span>
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import UploadMultipleFile from "@/components/UploadMultipleFile.vue";
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mask } from "vue-the-mask";

export default {
  props: ["resetForm", "loading"],
  components: {
    ValidationProvider,
    ValidationObserver,
    UploadSingleFile,
    UploadMultipleFile,
  },
  directives: {
    mask,
  },
  data() {
    return {
      input: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        policy_type: "",
        // certificate_no: "",
        company_name: "",
        policy_no: "",
        id_card_no: "",
        claim_type: "ผู้ป่วยนอก (OPD)",
        treatment: "",
        medical_expenses: "",
        receipt_file: "",
        medical_citificate_file: "",
        book_bank_file: "",
        other_file: [],
        national_id_card_photo: "",
      },
      policyTypeOptions: [
        {
          label: "ประกันชีวิต Ordinary Life",
          value: "OL",
        },
        {
          label: "ประกันสุขภาพและอุบัติเหตุ Accident and Health",
          value: "AH",
        },
        { label: "ประกันกลุ่มสวัสดิการ Group company", value: "G" },
      ],
      treatmentTypeOptions: [
        {
          label: "อุบัติเหตุ (Accident)",
          value: "อุบัติเหตุ",
        },
        {
          label: "เจ็บป่วยสุขภาพ (Health)",
          value: "เจ็บป่วย",
        },
        {
          label: "ชดเชยรายได้ (Hospital Income)",
          value: "ชดเชยรายได้",
        },
      ],
      acceptConsent: false,
    };
  },
  watch: {
    resetForm() {
      this.handleResetForm();
    },
  },
  methods: {
    async handleSubmit() {
      const vm = this;
      try {
        const isValid = await vm.$refs.observer.validate();

        if (isValid) {
          vm.$emit("onSubmit", { form_type: "new", ...vm.input });
        } else {
          const el = document.querySelector(".has-error:first-of-type");
          el.scrollIntoView({ block: "start", behavior: "smooth" });
          return false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleResetForm() {
      this.input = {
        name: "",
        surname: "",
        email: "",
        phone: "",
        policy_type: "",
        // certificate_no: "",
        company_name: "",
        policy_no: "",
        id_card_no: "",
        claim_type: "ผู้ป่วยนอก (OPD)",
        treatment: "",
        medical_expenses: "",
        receipt_file: "",
        medical_citificate_file: "",
        book_bank_file: "",
        other_file: [],
        national_id_card_photo: "",
      };
      this.$refs.observer.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.error-text {
  font-size: 12px;
  padding: 8px;
  letter-spacing: 0.3px;
}
</style>
